export const LOAD_USER_ROLES = "loadUserRoles";
export const LOAD_SITE_ROLES = "loadSiteRoles";
